// The project's push remote (settings → Git) and cloning a project from a repository.
export default {
	gitRemote: {
		title: "Git remote",
		hint: "The server pushes this project's history to the remote set up here — after each automatic build, and after every release with its tag.",
		url: "Repository URL",
		urlHelp: "https://…, ssh://… or user{'@'}host:path",
		urlInvalid:
			"Use an https, http or ssh URL, or user{'@'}host:path. A path on the server is not allowed.",
		branch: "Branch",
		auth: "Authentication",
		authNone: "None",
		authToken: "Token",
		authSsh: "SSH key",
		username: "Username",
		usernameHelp: "The name your git server takes with the token. Most accept any.",
		token: "Token",
		sshKey: "SSH private key",
		sshKeyHelp: "Paste the whole key, with its BEGIN and END lines.",
		secretStored: "A token or key is stored. It is never shown again.",
		replaceSecret: "Replace it",
		keepSecret: "Keep the stored one",
		secretNeeded: "A token or key is needed.",
		save: "Save",
		remove: "Stop pushing",
		pushNow: "Push now",
		statusNone: "No remote: this project is not pushed anywhere.",
		statusNever: "Not pushed yet.",
		statusOk: "Last pushed {time}.",
		statusFailed: "The last push, {time}, failed:",
		saved: "Remote saved. The next push goes there.",
		removed: "The project is no longer pushed.",
		pushed: "Pushed.",
		pushFailed: "The push failed.",
		readOnly: "Only a member who may write to the project's history can change this.",
	},
	cloneProject: {
		title: "Clone from git",
		hint: "Creates a new project from the repository of a Notitia project. You become its admin, and the repository becomes its push remote.",
		action: "Clone",
	},
};
